import { Box, Typography } from '@mui/material';
import { ReactElement } from 'react';

const TitleCard = (props: any): ReactElement => {
    const { title, subTitle } = props;

    // UI Elements
    return (
        <Box className="flex-column ">
            <Typography className="title-left">{title}</Typography>
            <Typography className="lato-regular mt-2" variant="body1">
                {subTitle}
            </Typography>
        </Box>
    );
};

export default TitleCard;
